// extracted by mini-css-extract-plugin
export default {"GridBlockCard":"MainDashboard_GridBlockCard__EVhqo"};